module.exports = __webpack_public_path__ + "img/first-section-img.2c561af7.svg";